const getClientApiUrl = () => {
  let url = '';
  if (typeof window !== 'undefined' && window.env && window.env === 'production') {
    url = 'https://api.hipages.com.au/';
  } else {
    url = 'https://master-attachments-api.k8s.hipages.com.au/';
  }
  return `${url}v1/attachments`;
};

export const attachmentUrl = getClientApiUrl();
